import { createContext } from 'react';
import type { EditModeContextState } from './editMode.types.js';

/**
 * React Context for decoration edit mode functionality.
 * Separated into a .ts file so EditModeContext.tsx exports only components
 * (required for React Fast Refresh / HMR compatibility).
 */
export const EditModeContext = createContext<EditModeContextState | null>(null);
